import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';

import {labelTextStyle} from './default';

const baseStyle = new Style({
	zIndex: 100,
	fill: new Fill({
		color: '#ef4122',
	}),
	stroke: new Stroke({
		width: 2,
		color: 'rgba(255,246,246,0.8)',
	}),
});

/**
 * @param {import('ol/Feature').default} feature
 * @returns {Style}
 */
export default function (feature) {
	const props = feature.getProperties();
	//const type = props.type || 'default';

	if (props.number) {
		const labelStyle = labelTextStyle.clone();
		labelStyle.setText(props.number.trim());
		//labelStyle.getStroke().setColor(defaultBaseStyles[type].getFill().getColor());

		const style = baseStyle.clone();
		style.setText(labelStyle);
		return style;
	}

	return baseStyle;
}
